/**
 * ThemeSpacingDefinition.tsx
 * Definición centralizada de espaciados, márgenes y dimensiones
 */

export const SPACING = {
    base: 8,

    0: "0px",
    0.5: "4px",
    1: "8px",
    1.5: "12px",
    2: "16px",
    2.5: "20px",
    3: "24px",
    3.5: "28px",
    3.75: "30px",
    4: "32px",
    5: "40px",
    6: "48px",
    8: "64px",
    10: "80px",
    12: "96px",
    16: "128px",
    20: "160px",
    24: "192px",
} as const;

export const PADDING = {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
} as const;

export const MARGIN = {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
} as const;

export const GAP = {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
} as const;

export const BREAKPOINTS = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
} as const;

export const COMPONENT_SIZES = {
    buttonSmall: "32px",
    buttonDefault: "40px",
    buttonLarge: "48px",

    drawerWidth: "350px",
    maxContentWidth: "1200px",

    iconSmall: "20px",
    iconDefault: "24px",
    iconMedium: "32px",
    iconLarge: "40px",
} as const;

export const Z_INDEX = {
    base: 0,
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
    notification: 1080,
    banner: 1400,
    header: 1300,
} as const;

export type Spacing = typeof SPACING;
